import classNames from 'classnames'
import React, { HTMLProps, PropsWithChildren } from 'react'
import { Outlet } from 'react-router-dom'

import logo from '@assets/images/logo.png'

import s from './AuthLayout.module.scss'
import { AuthLayoutProps } from './AuthLayout.props'

export function AuthLayout({ ...props }: AuthLayoutProps) {
  return (
    <div className={s.layout}>
      <div className={s.modal}>
        <div className={s.logo}>
          <img
            src={logo}
            alt="Crazyfish logo"
          />
        </div>

        <Outlet />
      </div>
    </div>
  )
}

export function AuthTitle({ children }: PropsWithChildren) {
  return <h1 className={s.title}>{children}</h1>
}

export function AuthText({ children, className }: PropsWithChildren<HTMLProps<HTMLParagraphElement>>) {
  return <p className={classNames(s.desc, className)}>{children}</p>
}
